import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ArticleTaxonomyAnalysisComponent } from './article-taxonomy-analysis/article-taxonomy-analysis.component';
import { CategoryAnalysisComponent } from './category-analysis/category-analysis.component';
import { SuperAdminTaxonomyComponent } from './super-admin-taxonomy.component';
import { SystemConfidenceAnalysisComponent } from './system-confidence-analysis/system-confidence-analysis.component';
import { TaxonomyDashboardComponent } from './taxonomy-dashboard/taxonomy-dashboard.component';
import { TaxonomyDimensionsListComponent } from './taxonomy-dimensions-list/taxonomy-dimensions-list.component';

const routes: Routes = [
  {
    path: '',
    component: SuperAdminTaxonomyComponent,
  },
  {
    path: ':tenantId',
    component: TaxonomyDimensionsListComponent,
  },
  {
    path: ':tenantId/:dimensionId',
    component: TaxonomyDashboardComponent,
  },
  {
    path: ':tenantId/article/:articleId',
    component: ArticleTaxonomyAnalysisComponent,
  },
  {
    path: ':tenantId/:dimensionId/article/:articleId',
    component: ArticleTaxonomyAnalysisComponent,
  },
  {
    path: ':tenantId/:dimensionId/category/:categoryId',
    component: CategoryAnalysisComponent,
  },
  {
    path: ':tenantId/:dimensionId/system-confidence-analysis',
    component: SystemConfidenceAnalysisComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SuperAdminTaxonomyRoutingModule {}
